module.exports = __webpack_public_path__ + "fonts/Lato-Semibold.3b0cd725.ttf";